import type { HTMLAttributes } from "react";

export type NoticeTone = "error" | "success" | "info";

interface NoticeProps extends Omit<HTMLAttributes<HTMLDivElement>, "role"> {
  tone?: NoticeTone;
  role?: "alert" | "status" | "note";
}

/**
 * Единая плашка сообщения: ошибка, успех, пояснение.
 *
 * Отступы сверху и снизу задаёт сама плашка (`.notice` в styles.css), поэтому
 * она не прилипает ни к кнопке выше, ни к полю ниже. Крайний ребёнок
 * контейнера отступ наружу не даёт, сетки и flex-контейнеры с `gap`
 * обнуляют его контекстным правилом.
 */
export function Notice({
  tone = "error",
  role,
  className,
  ...rest
}: NoticeProps) {
  return (
    <div
      {...rest}
      role={role ?? (tone === "error" ? "alert" : "status")}
      className={`notice notice--${tone}${className ? ` ${className}` : ""}`}
    />
  );
}
